import { breaksForDay, overlapsBreak } from './breakHelpers'

export const toEnglishNumbers = str => {
  return str.replace(/[٠١٢٣٤٥٦٧٨٩]/g, d => d.charCodeAt(0) - 1632).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, d => d.charCodeAt(0) - 1776)
}

// How a conversation is addressed on screen: by number, or by WhatsApp username when the contact hides their number
export const getConversationHandle = ({ phone, username, bsuid } = {}) =>
  phone ? `+${phone}` : username ? `@${username}` : bsuid || ''

export const paymentsTypes = [
  'CASH',
  'CARD',
  'INSURANCE',
  'CHEQUE',
  'BALANCE',
  'VOUCHER',
  'BANK_TRANSFER',
  'MOBILE_WALLET',
  'OTHER'
]
export const operationsTypes = ['PLANNED', 'IN_PROGRESS', 'COMPLETED', 'EXISTING', 'REJECTED']
export const paymentTypesColors = {
  CASH: '#5fcb28',
  CARD: '#6495f9',
  BALANCE: '#75cbed',
  INSURANCE: '#e84ba2',
  CHEQUE: '#894ae2',
  VOUCHER: '#154498',
  BANK_TRANSFER: '#d0c226',
  MOBILE_WALLET: '#e08121',
  OTHER: '#657798'
}
export const paymentTypesWithRefundColors = {
  CASH: '#5fcb28',
  CARD: '#6495f9',
  BALANCE: '#75cbed',
  INSURANCE: '#e84ba2',
  CHEQUE: '#894ae2',
  VOUCHER: '#154498',
  BANK_TRANSFER: '#d0c226',
  MOBILE_WALLET: '#e08121',
  REFUND: '#ff3e3e',
  OTHER: '#657798'
}
export const paymentTypesWithBankColors = {
  CASH: '#5fcb28',
  BANK: '#003fc4',
  SAFE: '#c47f00',
  CARD: '#6495f9',
  BALANCE: '#75cbed',
  INSURANCE: '#e84ba2',
  CHEQUE: '#894ae2',
  VOUCHER: '#154498',
  BANK_TRANSFER: '#d0c226',
  MOBILE_WALLET: '#e08121',
  OTHER: '#657798'
}
export const invoiceColors = ['#5fcb28', '#d73939', '#657798']
export const operationsTypesColors = {
  EXISTING: '#657798',
  PLANNED: '#ee5353',
  COMPLETED: '#5dbb62',
  REJECTED: '#9b37cd',
  IN_PROGRESS: '#6495f9',
  CONDITION: '#986430'
}

export const jobs = ['doctor', 'nurse', 'accountant', 'admin']

export const formatBytes = (a, b) => {
  if (a === 0) return '0 Bytes'
  const c = 1024
  const d = b || 2
  const e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const f = Math.floor(Math.log(a) / Math.log(c))
  return `${a > 0 ? '' : '- '}${parseFloat((Math.abs(a) / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]}`
}

export function msToTime(s) {
  function pad(n, z) {
    z = z || 2
    return ('00' + n).slice(-z)
  }

  const ms = s % 1000
  s = (s - ms) / 1000
  const secs = s % 60
  s = (s - secs) / 60
  const mins = s % 60
  const hrs = (s - mins) / 60

  return (hrs > 99 ? hrs : pad(hrs)) + ' : ' + pad(mins) + ' : ' + pad(secs)
}

export const genders = ['male', 'female']

export const maritalStatuses = ['married', 'single', 'divorced', 'separated', 'widowed']

export const securityLogsColors = {
  'Failed Login': '#ff0000',
  'Password Change': '#ff0000',
  'Email Change': '#ff0000',
  'Password Reset Attempt': '#e8692a',
  'Disable 2FA': '#e8692a',
  'Successful Password Reset': '#e8692a',
  'Enable 2FA': '#0d72bb',
  'Successful Login': '#87d068'
}

export const deletedItemsColors = {
  PATIENTBALANCE: '#ff0000',
  INVOICE: '#ff0000',
  PAYMENT: '#ff0000',
  PRICELIST: '#ff0000',
  TREASURY: '#ff0000',
  QUOTATION: '#ff0000',
  INVENTORYUSAGE: '#e8692a',
  REMINDERINSTANCE: '#e8692a',
  TOPUP: '#e8692a',
  MONTHLYEXPENSE: '#e8692a',
  EXPENSE: '#e8692a',
  EXPENSE_PAYMENT: '#e8692a',
  INCOME: '#e8692a',
  TRANSACTION: '#e8692a',
  APPOINTMENT: '#0d72bb',
  OPERATION: '#0d72bb',
  INSURANCECOMPANY: '#0d72bb',
  PATIENTREMINDERS: '#0d72bb',
  LAB: '#0d72bb',
  SUPPLIER: '#0d72bb',
  LABORDER: '#0d72bb',
  INVENTORY: '#0d72bb',
  PATIENT: '#0d72bb',
  MESSAGE: '#2db7f5',
  PROCEDURE: '#2db7f5',
  MEDICAL: '#2db7f5',
  CLINICAL: '#2db7f5',
  CONDITION: '#2db7f5',
  FIELD: '#87d068',
  MEDICATION: '#87d068',
  FORM: '#87d068',
  FILE: '#87d068',
  XRAY: '#87d068',
  GROUP: '#87d068',
  SALARY_ADJUSTMENT: '#87d068',
  TASK: '#87d068',
  PRESCRIPTION: '#87d068',
  NOTE: '#87d068',
  ENCOUNTER: '#87d068'
}

export const sanitizeContent = details => details?.replace(/<(.|\n)*?>/g, '').trim() ?? ''

export const alphabet = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
]

export const patientJobs = [
  'Chiropractor',
  'Doctor',
  'Dentist',
  'Dietitian or Nutritionist',
  'Optometrist',
  'Pharmacist',
  'Physician',
  'Physician Assistant',
  'Podiatrist',
  'Registered Nurse',
  'Therapist',
  'Veterinarian',
  'Health Technologist or Technician',
  'Other Healthcare Practitioners and Technical Occupation',
  'Nursing, Psychiatric, or Home Health Aide',
  'Occupational and Physical Therapist Assistant or Aide',
  'Other Healthcare Support Occupation',
  'Chief Executive',
  'General and Operations Manager',
  'Advertising, Marketing, Promotions, Public Relations, and Sales Manager',
  'Operations Specialties Manager (e.g., IT or HR Manager)',
  'Construction Manager',
  'Engineering Manager',
  'Accountant, Auditor',
  'Business Operations or Financial Specialist',
  'Business Owner',
  'Other Business, Executive, Management, Financial Occupation',
  'Architect, Surveyor, or Cartographer',
  'Engineer',
  'Other Architecture and Engineering Occupation',
  'Postsecondary Teacher (e.g., College Professor)',
  'Primary, Secondary, or Special Education School Teacher',
  'Other Teacher or Instructor',
  'Other Education, Training, and Library Occupation',
  'Arts, Design, Entertainment, Sports, and Media Occupations',
  'Computer Specialist, Mathematical Science',
  'Counselor, Social Worker, or Other Community and Social Service Specialist',
  'Lawyer, Judge',
  'Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)',
  'Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)',
  'Religious Worker (e.g., Clergy, Director of Religious Activities or Education)',
  'Social Scientist and Related Worker',
  'Other Professional Occupation',
  'Supervisor of Administrative Support Workers',
  'Financial Clerk',
  'Secretary or Administrative Assistant',
  'Material Recording, Scheduling, and Dispatching Worker',
  'Other Office and Administrative Support Occupation',
  'Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)',
  'Chef or Head Cook',
  'Cook or Food Preparation Worker',
  'Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)',
  'Building and Grounds Cleaning and Maintenance',
  'Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)',
  'Sales Supervisor, Retail Sales',
  'Retail Sales Worker',
  'Insurance Sales Agent',
  'Sales Representative',
  'Real Estate Sales Agent',
  'Other Services Occupation',
  'Construction and Extraction (e.g., Construction Laborer, Electrician)',
  'Farming, Fishing, and Forestry',
  'Installation, Maintenance, and Repair',
  'Production Occupations',
  'Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation',
  'Aircraft Pilot or Flight Engineer',
  'Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)',
  'Other Transportation Occupation',
  'Military',
  'Homemaker',
  'Other Occupation',
  "Don't Know",
  'Not Applicable'
]

export const expenseMainTypes = [
  { value: 'OPERATING_EXPENSES', color: 'cyan' },
  { value: 'COST_OF_REVENUE', color: 'blue' },
  { value: 'TAX', color: 'purple' },
  { value: 'OTHER', color: 'red' }
]

// the headings a stock count's export uses, the same as its tables, over the general ones
export const stockCountKeyNames = {
  number: 'app.count',
  inventoryStorage: 'app.storage',
  isMaster: 'app.stockCountMaster',
  totalItems: 'app.totalItems',
  countedItems: 'app.counted',
  expectedAmount: 'app.expectedAmount',
  expectedAmountBox: 'app.expectedAmountBox',
  expectedValue: 'app.expectedValue',
  countedAmount: 'app.countedAmount',
  countedAmountBox: 'app.countedAmountBox',
  countedValue: 'app.countedValue',
  varianceAmount: 'app.variance',
  varianceValue: 'app.varianceValue',
  stockUpdated: 'app.stock',
  inventoryOrder: 'app.inventoryOrder',
  confirmedAt: 'app.confirmedAt',
  confirmedBy: 'app.confirmedBy',
  code: 'settings.procedures.code',
  box: 'app.box',
  price: 'settings.procedures.price',
  due: 'app.expires',
  inventoryItem: 'logs.INVENTORY',
  inventorySubItem: 'app.stockCountVariation',
  inventoryLocation: 'support.location',
  itemName: 'logs.INVENTORY',
  subItemName: 'app.stockCountVariation',
  countedAt: 'app.countedAt',
  countedBy: 'app.countedBy',
  pickedDue: 'app.dueToAdjust',
  batch: 'app.batch',
  note: 'common.details'
}

export const tableKeyNames = {
  firstName: 'calendar.firstName',
  lastName: 'calendar.lastName',
  referenceId: 'patients.patientId',
  patientId: 'app.patientId',
  customId: 'app.customId',
  invoiceId: 'app.invoiceId',
  credit: 'app.credit',
  stepPayment: 'app.paymentSteps',
  treasury: 'app.treasury',
  operationStep: 'app.operationSteps',
  calculation: 'app.calculation',
  insurance: 'calendar.insurance',
  phoneNumber: 'common.yourPhone',
  phoneNumber2: 'common.phoneNumber2',
  hasValidNumber: 'common.hasValidNumber',
  gender: 'calendar.gender',
  marital: 'patients.marital',
  email: 'common.email',
  procedureQuantity: 'Procedure Quantity',
  procedurePrice: 'Procedure Price',
  procedureDiscount: 'Procedure Discount',
  netPrice: 'Net Price',
  insuranceLimit: 'calendar.insuranceLimit',
  insured: 'Insured',
  insuranceUnlimited: 'calendar.unlimited',
  insurancePercentage: 'settings.account.insurancePercentage',
  disabled: 'common.disabled',
  details: 'common.details',
  firstPaymentDate: 'app.firstPaymentDate',
  patientDueDate: 'app.patientDueDate',
  firstNameE: 'calendar.firstNameE',
  lastNameE: 'calendar.lastNameE',
  phoneNumberE: 'calendar.phoneNumberE',
  addressE: 'calendar.addressE',
  relationE: 'patients.relationship',
  country: 'common.country',
  address: 'common.address',
  phoneNumber2E: 'calendar.phoneNumber2E',
  birthDate: 'common.birthDate',
  age: 'common.age',
  points: 'points.points',
  firstToExpire: 'points.firstToExpire',
  balanceInvoice: 'Is Balance Invoice',
  totalPaid: 'dashboardHome.totalPayments',
  dailyAmountPaid: 'app.dailyAmountPaid',
  lastPaymentDate: 'app.lastPaymentDate',
  lastInteraction: 'app.lastInteraction',
  order: 'app.order',
  journeyedAt: 'app.journeyedAt',
  stagedAt: 'app.stagedAt',
  dealSize: 'app.dealSize',
  score: 'app.score',
  rejectReason: 'app.rejectReason',
  stage: 'app.stage',
  assignedTo: 'calendar.assignedTo',
  totalInsurance: 'dashboardHome.insuranceCoverage',
  balance: 'settings.inventory.balance',
  branch: 'settings.inventory.branch',
  insuranceCompany: 'calendar.insuranceCompany',
  pending: 'app.pending',
  birthDay: 'common.birthDayValid',
  longitude: 'dashboardHome.addressValid',
  title: 'common.title',
  doctor: 'common.doctor',
  priceList: 'patients.priceListG',
  createdAt: 'common.created',
  updatedAt: 'common.lastUpdated',
  createdBy: 'common.createdBy',
  updatedBy: 'common.lastUpdatedBy',
  referralSource: 'patients.referral',
  referralSubSource: 'app.referralSubtype',
  referralDetails: 'patients.referralDetails',
  referralUser: 'patients.fromUser',
  referralPatient: 'patients.fromPatient',
  appointments: 'sidebar.appointments',
  history: 'logs.OPERATION',
  referrals: 'patients.referrals',
  patient: 'calendar.patient',
  date: 'common.date',
  remindedAt: 'settings.patientReminders.reminded',
  name: 'common.name',
  at: 'settings.messages.at',
  automatic: 'settings.patientReminders.sendAutoSms',
  operation: 'patients.procedure',
  type: 'settings.medications.type',
  strength: 'settings.medications.strength',
  method: 'settings.medications.method',
  dispense: 'settings.medications.dispense',
  dosage: 'settings.medications.dosageTitle',
  duration: 'settings.medications.durationTitle',
  procedure: 'patients.procedure',
  procedures: 'patients.procedures',
  condition: 'patients.condition',
  price: 'settings.procedures.price',
  expenseType: 'dashboardHome.expensesTypes',
  total: 'settings.account.total',
  status: 'calendar.status',
  child: 'settings.branches.childTeeth',
  amount: 'settings.inventory.amountTitle',
  invoice: 'patients.invoice',
  appointment: 'common.appointment',
  diagnosticFee: 'settings.account.diagnosticFee',
  subtotal: 'settings.account.subtotal',
  discount: 'settings.account.discount',
  discountPercent: 'settings.account.discountPercent',
  tax: 'settings.account.tax',
  taxPercent: 'settings.account.taxPercent',
  pendingPayment: 'settings.account.pendingPayment',
  pendingPaymentPercent: 'settings.account.pendingPaymentPercent',
  paid: 'settings.account.paid',
  paidInFull: 'settings.account.paidInFull',
  user: 'settings.expenses.user',
  other: 'calendar.other',
  start: 'clock.start',
  end: 'clock.end',
  isOnline: 'calendar.isOnline',
  urgent: 'calendar.urgent',
  alert: 'calendar.alert',
  waitingDuration: 'dashboardHome.waitingTime',
  started: 'clock.started',
  checked: 'calendar.CHECKEDIN',
  createdIp: 'clock.startIp',
  updatedIp: 'clock.endIp',
  startUseragent: 'clock.startUseragent',
  endUseragent: 'clock.endUseragent',
  startImage: 'clock.startImage',
  endImage: 'clock.endImage',
  content: 'settings.messages.messageContent',
  receivedPatient: 'settings.messages.receivedPatient',
  receivedUser: 'settings.messages.receivedUser',
  items: 'settings.inventory.quantity',
  due: 'app.expires',
  expense: 'expenses.expenseInfo',
  lab: 'app.lab',
  labItem: 'app.labItem',
  paidAt: 'app.paidAt',
  received: 'app.received',
  receivedAt: 'app.receivedAt',
  refundedAt: 'Refund Date',
  refundedBy: 'settings.expenses.user',
  claimed: 'app.claimed',
  refunded: 'app.refunded',
  paymentType: 'calendar.paymentType',
  feedback: 'support.feedback',
  feedbackRating: 'support.feedback',
  feedbackIP: 'app.feedbackIP',
  feedbackAt: 'Feedback Date',
  room: 'calendar.room',
  diagnosticFeeInvoice: 'settings.account.diagnosticFee',
  updated: 'app.priceUpdated',
  cost: 'app.cost',
  approved: 'app.isApproved',
  insuranceDiscount: 'calendar.insuranceDiscount',
  insuranceNumber: 'app.insuranceNumber',
  insuranceGroup: 'app.insuranceGroup',
  insuranceCRT: 'app.insuranceCRT',
  signed: 'app.signed',
  signRequired: 'app.signRequired',
  approvalRequired: 'app.approvalRequired',
  approvalNumber: 'dhs.approvalNumber',
  approvalStatus: 'dhs.approvalStatus',
  responseDate: 'dhs.responseDate',
  canceledAt: 'dhs.canceledAt',
  canceledBy: 'dhs.canceledBy',
  manualUpdatedBy: 'dhs.manualUpdatedBy',
  insuranceEndDate: 'app.insuranceEndDate',
  insuranceStartMonth: 'app.insuranceStartMonth',
  nationality: 'dashboardHome.patientsNationality',
  nationalId: 'app.nationalId',
  latitude: 'Latitude',
  job: 'common.job',
  tags: 'app.patientTags',
  images: 'patients.files',
  customFields: 'settings.groups.customFields',
  branchId: 'settings.inventory.branch',
  doctorId: 'common.doctor',
  salaryAdjustment: 'app.salaryAdjustment',
  users: 'sidebar.users',
  appointmentId: 'common.appointment',
  code: 'settings.procedures.code',
  procedureId: 'patients.procedure',
  conditionItemId: 'patients.condition',
  tooth: 'app.tooth',
  steps: 'app.steps',
  package: 'app.pulses',
  remaining: 'settings.account.remaining',
  remainingPackage: 'app.remainingPulses',
  remainingCost: 'app.remainingCost',
  whatsapp: 'Whats App',
  after: 'app.dueDateAfter',
  interval: 'settings.patientReminders.interval',
  cancelReason: 'calendar.cancelReason',
  forOperator: 'app.forOperator',
  notifyAt: 'calendar.notify',
  assistants: 'app.assistants',
  OPEN: 'calendar.OPEN',
  CONFIRMED: 'calendar.CONFIRMED',
  CHECKEDIN: 'calendar.CHECKEDIN',
  INPROGRESS: 'calendar.INPROGRESS',
  COMPLETED: 'calendar.COMPLETED',
  DELAYED: 'calendar.DELAYED',
  CANCELED: 'calendar.CANCELED',
  NOSHOW: 'calendar.NOSHOW',
  WAITING: 'calendar.WAITING',
  NOTE: 'calendar.NOTE',
  PLANNED: 'calendar.PLANNED',
  CONDITION: 'patients.condition',
  IN_PROGRESS: 'calendar.INPROGRESS',
  REJECTED: 'calendar.REJECTED',
  EXISTING: 'calendar.EXISTING',
  CASH: 'settings.expenses.CASH',
  CARD: 'settings.expenses.CARD',
  INSURANCE: 'settings.expenses.INSURANCE',
  CHEQUE: 'settings.expenses.CHEQUE',
  BALANCE: 'settings.expenses.BALANCE',
  VOUCHER: 'settings.expenses.VOUCHER',
  BANK_TRANSFER: 'settings.expenses.BANK_TRANSFER',
  MOBILE_WALLET: 'settings.expenses.MOBILE_WALLET',
  OTHER: 'settings.expenses.OTHER',
  patientCreateDate: 'app.patientCreation',
  repeat: 'app.repeat',
  reschedule: 'app.whatsappReschedule',
  patientConfirm: 'app.confirmedOrder',
  onlinePayment: 'app.onlinePayments',
  appointmentFeedback: 'support.feedback',
  totalRemaining: 'settings.account.remaining',
  prevAppointment: 'dashboardHome.prevAppointment',
  activeAppointment: 'dashboardHome.activeAppointment',
  lastAppointment: 'dashboardHome.lastAppointment',
  hasPendingMedical: 'support.pendingMedicalConfirmation'
}

export const translatedKeys = {
  OPEN: 'calendar.OPEN',
  CONFIRMED: 'calendar.CONFIRMED',
  CHECKEDIN: 'calendar.CHECKEDIN',
  INPROGRESS: 'calendar.INPROGRESS',
  COMPLETED: 'calendar.COMPLETED',
  DELAYED: 'calendar.DELAYED',
  CANCELED: 'calendar.CANCELED',
  NOSHOW: 'calendar.NOSHOW',
  WAITING: 'calendar.WAITING',
  NOTE: 'calendar.NOTE',
  PLANNED: 'calendar.PLANNED',
  CONDITION: 'patients.condition',
  IN_PROGRESS: 'calendar.INPROGRESS',
  REJECTED: 'calendar.REJECTED',
  EXISTING: 'calendar.EXISTING',
  CASH: 'settings.expenses.CASH',
  CARD: 'settings.expenses.CARD',
  INSURANCE: 'settings.expenses.INSURANCE',
  CHEQUE: 'settings.expenses.CHEQUE',
  BALANCE: 'settings.expenses.BALANCE',
  VOUCHER: 'settings.expenses.VOUCHER',
  BANK_TRANSFER: 'settings.expenses.BANK_TRANSFER',
  MOBILE_WALLET: 'settings.expenses.MOBILE_WALLET',
  OTHER: 'settings.expenses.OTHER',
  PURCHASE: 'app.purchase',
  USAGE: 'app.usage',
  TRANSFER: 'app.transfer',
  DISTRIBUTION: 'app.distribution',
  SALE: 'app.sale',
  REFUND: 'app.refund',
  RETURN: 'app.return',
  DISPOSAL: 'app.disposal',
  ADJUSTMENT: 'app.adjustment',
  PROFIT: 'app.profit'
}

export const getEnumTypes = user => ({
  inventoryItems: JSON.parse(user.company.inventoryTypes),
  inventorySubItems: JSON.parse(user.company.inventoryTypes),
  inventoryType: JSON.parse(user.company.inventoryTypes),
  inventoryLocations: JSON.parse(user.company.inventoryTypes),
  expenses: JSON.parse(user.company.expenseTypes),
  expensePayments: JSON.parse(user.company.expenseTypes),
  incomes: JSON.parse(user.company.incomeTypes),
  payments: JSON.parse(user.company.paymentTypes),
  EDIT_PAYMENT: JSON.parse(user.company.paymentTypes),
  appointments: JSON.parse(user.company.appointmentTypes),
  EDIT_APPOINTMENT: JSON.parse(user.company.appointmentTypes),
  createdAppointments: JSON.parse(user.company.appointmentTypes),
  appointmentType: JSON.parse(user.company.appointmentTypes),
  salaryAdjustments: JSON.parse(user.company.salaryAdjustmentTypes)
})

export const getUserActionText = ({ field, t, enumTypes, userActionDetails, moment }) =>
  `${
    Object.keys(field)?.[0] && tableKeyNames[Object.keys(field)?.[0]]
      ? t(tableKeyNames[Object.keys(field)?.[0]])
      : Object.keys(field)?.[0]
  }: ${
    field[Object.keys(field)[0]] &&
    typeof field[Object.keys(field)[0]] === 'string' &&
    field[Object.keys(field)[0]].startsWith('Enum') &&
    (enumTypes[Object.keys(field)[0]] || enumTypes[userActionDetails.action])
      ? field[Object.keys(field)[0]]
          .split(',')
          .map(s =>
            t((enumTypes[Object.keys(field)[0]] || enumTypes[userActionDetails.action]).find(type => type.enum === s)?.name ?? s)
          )
          .join(', ')
      : Object.keys(field)[0] === 'tooth' && field[Object.keys(field)[0]]?.split?.(',').length
      ? ''
      : field[Object.keys(field)[0]] && tableKeyNames[field[Object.keys(field)[0]]]
      ? t(tableKeyNames[field[Object.keys(field)[0]]])
      : field[Object.keys(field)[0]] && !Number(field[Object.keys(field)[0]]) && moment(field[Object.keys(field)[0]]).isValid()
      ? moment(field[Object.keys(field)[0]]).format('lll')
      : field[Object.keys(field)[0]]
  }`

// What Meta accepts as a template name is lowercase letters, digits and underscores; the server lowercases the name
// and turns its spaces into underscores before submitting, so what the user may type is English letters, digits, spaces
// and underscores
export const WHATSAPP_TEMPLATE_NAME = /^[A-Za-z0-9 _]+$/

export const userActionTypes = [
  { value: 'NEW_APPOINTMENT', title: 'common.newApp', color: 'blue', forWhatsApp: true },
  { value: 'NEW_PAYMENT', title: 'settings.inventory.addPayment', color: 'blue' },
  { value: 'NEW_PATIENT', title: 'patients.newPatient', color: 'blue' },
  { value: 'NEW_INVOICE', title: 'settings.procedures.createInvoice', color: 'blue' },
  { value: 'NEW_OPERATION', title: 'settings.medications.newOperation', color: 'blue' },
  { value: 'NEW_EXPENSE', title: 'expenses.newExpense', color: 'blue' },
  { value: 'NEW_EXPENSE_PAYMENT', title: 'logs.EXPENSE_PAYMENT', color: 'blue' },
  { value: 'NEW_INCOME', title: 'incomes.newIncome', color: 'blue' },
  { value: 'NEW_NOTE', title: 'support.newNote', color: 'blue' },
  { value: 'NEW_LAB_ORDER', title: 'app.newLabOrder', color: 'blue' },
  { value: 'NEW_PRESCRIPTION', title: 'settings.medications.createNewPrescription', color: 'blue' },
  { value: 'NEW_PATIENT_ENCOUNTER', title: 'encounters.newEncounter', color: 'blue' },
  { value: 'NEW_PATIENT_FORM', title: 'app.newPatientForm', color: 'blue' },
  { value: 'NEW_QUOTATION', title: 'settings.procedures.createQuotation', color: 'blue' },
  { value: 'NEW_INVENTORY_USAGE', title: 'sidebar.branchUsage', color: 'purple' },
  { value: 'NEW_MASTER_USAGE', title: 'sidebar.masterUsage', color: 'purple' },
  { value: 'EDIT_PAYMENT', title: 'app.editPayment', color: 'red' },
  { value: 'EDIT_INVOICE', title: 'app.editInvoice', color: 'red' },
  { value: 'EDIT_OPERATION', title: 'app.editOperation', color: 'red' },
  { value: 'EDIT_APPOINTMENT', title: 'calendar.editApp', color: 'orange' },
  { value: 'EDIT_PATIENT', title: 'patients.editPatient', color: 'orange' },
  { value: 'EDIT_INVOICE_DISCOUNT', title: 'app.editDiscount', color: 'orange' },
  { value: 'EDIT_EXPENSE', title: 'expenses.editExpense', color: 'orange' },
  { value: 'EDIT_EXPENSE_PAYMENT', title: 'app.editExpensePayment', color: 'orange' },
  { value: 'EDIT_INCOME', title: 'incomes.editIncome', color: 'orange' },
  { value: 'EDIT_NOTE', title: 'support.editNote', color: 'orange' },
  { value: 'EDIT_LAB_ORDER', title: 'app.editLabOrder', color: 'orange' },
  { value: 'EDIT_INVENTORY_USAGE', title: 'app.editBranchUsage', color: 'orange' },
  { value: 'EDIT_MASTER_USAGE', title: 'app.editMasterUsage', color: 'orange' },
  { value: 'EDIT_PRESCRIPTION', title: 'settings.medications.editPrescription', color: 'orange' },
  { value: 'EDIT_PATIENT_ENCOUNTER', title: 'encounters.editEncounter', color: 'orange' },
  { value: 'EDIT_PATIENT_FORM', title: 'app.editPatientForm', color: 'orange' },
  { value: 'EDIT_CLINICAL_TEST', title: 'app.editClinicalTest', color: 'orange' },
  { value: 'EDIT_XRAY', title: 'app.editXray', color: 'orange' },
  { value: 'EDIT_QUOTATION', title: 'app.editQuotation', color: 'orange' },
  { value: 'REMOVE_OPERATION_FROM_INVOICE', title: 'app.removeOperation', color: 'orange' },
  { value: 'ADD_OPERATION_TO_INVOICE', title: 'patients.addOperations', color: 'orange' },
  { value: 'MOVE_PAYMENT_TO_BALANCE', title: 'app.movePayment', color: 'orange' },
  { value: 'SIGN_PAYMENT', title: 'app.signPayment', color: 'orange' },
  { value: 'SIGN_FREE_FORM', title: 'app.signFreeForm', color: 'orange' },
  { value: 'OPERATION_PRICE_ADJUSTMENT', title: 'app.profit', color: 'red' },
  { value: 'WHATSAPP_CALL_REQUEST', title: 'app.whatsappCall', color: 'red', forWhatsApp: true, forActions: false },
  { value: 'WHATSAPP_FOLLOW_REQUEST', title: 'app.whatsappFollow', color: 'red', forWhatsApp: true, forActions: false }
]

export const fetchMorePolicy = {
  keyArgs: [
    'orderBy',
    'parent',
    'branch',
    'branchId',
    'groupBy',
    'searchTerm',
    'rangeDate',
    'forDashboard',
    'currentUserTime',
    'filters',
    'userId',
    'patient',
    'appointment',
    'assignedToId',
    'insuranceCompany',
    'insuranceCompanies',
    'doctor',
    'showUpdatedInvoices',
    'pendingPayment',
    'disabled',
    'lead',
    'referralSource',
    'referralSubSource',
    'rejectReason',
    'leadStage',
    'patientTags',
    'patientTag',
    'priceList',
    'id',
    'inventoryId',
    'forUser',
    'referral',
    'user',
    'dateMode',
    'toStage',
    'starred',
    'currentStage',
    'company',
    'supplier',
    'start',
    'end',
    'lab',
    'forAppointmentUpdated',
    'treasury',
    'patientLink',
    'income',
    'inventory',
    'operation',
    'procedure',
    'procedureGroup',
    'version',
    'globalCondition',
    'operation',
    'operationStep',
    'inventoryLocationStorage',
    'labItem',
    'patientId',
    'counter',
    'expense',
    'payment',
    'by',
    'conversation',
    'selectedActions',
    'invoice',
    'inventoryItem',
    'inventorySubItem',
    'inventoryStorage',
    'inventoryLocation',
    'inventoryTransaction',
    'inventoryOrder',
    'storageIdSubItemId',
    'appointmentFeedbackQuestion',
    'companyId',
    'favouritesOnly',
    'resolved',
    'reported',
    'systemChat',
    'systemChatSkip',
    'stockCount'
  ],
  merge(existing, incoming, { args }) {
    if (args?.isTable) {
      return incoming
    }
    const merged = existing ? existing.slice(0) : []
    if (args) {
      const { skip = 0 } = args
      for (let i = 0; i < incoming.length; ++i) {
        merged[skip + i] = incoming[i]
      }
    } else {
      merged.push.apply(merged, incoming)
    }
    return merged.filter((v, i, a) => a.findIndex(t => t?.__ref === v?.__ref) === i)
  }
}

export const replacePolicy = {
  merge(existing, incoming) {
    return incoming
  }
}

export const getDoctorClosedHours = ({ calendarSettings, date, room, branchId, end, moment }) => {
  const i = moment(date).day()
  const hour = moment(date).hour()
  const minute = moment(date).minute()
  const endHour = moment(end).hour()
  const endMinute = moment(end).minute()

  if (
    (calendarSettings.closedDays && calendarSettings.closedDays.includes(i)) ||
    (calendarSettings.holidays && calendarSettings.holidays.includes(moment(date).dayOfYear()))
  ) {
    return true
  }

  const opensHour = calendarSettings.opens && calendarSettings.opens[i] ? Number(calendarSettings.opens[i].split('_')[0]) || 0 : 0
  const closesHour =
    calendarSettings.closes && calendarSettings.closes[i] ? Number(calendarSettings.closes[i].split('_')[0]) || 24 : 24
  const opensMinute =
    calendarSettings.opens && calendarSettings.opens[i] ? Number(calendarSettings.opens[i].split('_')[1]) || 0 : 0
  const closesMinute =
    calendarSettings.closes && calendarSettings.closes[i] ? Number(calendarSettings.closes[i].split('_')[1]) || 0 : 0
  const breaks = breaksForDay(calendarSettings.breaks, i)

  if (room && branchId) {
    const rooms =
      calendarSettings.rooms
        ?.filter(s => s[0] === branchId)
        .filter(s => s.length > 1)
        .map(s => s[1]) ?? []
    if (rooms.length && !rooms.includes(room)) {
      return true
    }
  }

  return (
    hour < opensHour ||
    (hour === opensHour && minute < opensMinute) ||
    hour > closesHour ||
    (hour === closesHour && minute >= closesMinute) ||
    (end && endHour === closesHour && endMinute > closesMinute) ||
    overlapsBreak(breaks, hour * 60 + minute, end ? endHour * 60 + endMinute : undefined) ||
    (end && endHour > closesHour)
  )
}

export const getUserActionExtraTranslation = extra => {
  switch (extra) {
    case 'refund':
      return 'app.refundPayment'
    case 'balance':
      return 'app.movePayment'
    case 'delete':
      return 'app.deletePayment'
    case 'new':
      return 'settings.inventory.addPayment'
    default:
      return extra
  }
}

export const familyRelations = [
  'PARENT',
  'CHILD',
  'SIBLING',
  'SPOUSE',
  'GRANDPARENT',
  'GRANDCHILD',
  'NIECE_OR_NEPHEW',
  'UNCLE_OR_AUNT',
  'COUSIN',
  'HALF_SIBLING',
  'STEPPARENT',
  'STEPCHILD',
  'STEP_SIBLING',
  'PARENT_IN_LAW',
  'CHILD_IN_LAW',
  'IN_LAW_SIBLING',
  'LEGAL_GUARDIAN',
  'WARD',
  'SIGNIFICANT_OTHER'
]

export const patientPointsActions = ['PAYMENT', 'REFERRAL', 'FEEDBACK', 'REFERRAL_FEEDBACK', 'MANUAL', 'TRANSFER', 'DISCOUNT']

export const googleDriveFolders = {
  getDriveName: ({
    insuranceCompany,
    lab,
    supplier,
    expense,
    inventoryItem,
    inventoryOrder,
    invoice,
    income,
    treasury,
    counter,
    folderName
  }) => {
    if (insuranceCompany) {
      return 'Insurance Companies'
    }
    if (lab) {
      return 'Labs'
    }
    if (supplier) {
      return 'Suppliers'
    }
    if (expense) {
      return 'Expenses'
    }
    if (inventoryItem) {
      return 'Inventory Items'
    }
    if (inventoryOrder) {
      return 'Inventory Orders'
    }
    if (invoice) {
      return 'Invoices'
    }
    if (income) {
      return 'Incomes'
    }
    if (treasury) {
      return 'Treasuries'
    }
    if (counter) {
      return 'Counters'
    }
    return folderName
  },
  signature: 'Signatures',
  attendance: 'Attendance',
  insuranceCompanies: 'Insurance Companies',
  labs: 'Labs',
  suppliers: 'Suppliers',
  expenses: 'Expenses',
  inventoryItems: 'Inventory Items',
  inventoryOrders: 'Inventory Orders',
  invoices: 'Invoices',
  incomes: 'Incomes',
  treasuries: 'Treasuries',
  counters: 'Counters'
}

export const queriesMaxDates = {
  userActions: 'month',
  communications: 'year'
}

export const queriesMaxDateIgnoredKeys = {
  userActions: ['id', 'userId', 'operation', 'appointment', 'invoice', 'patient', 'payment', 'note', 'patientEncounter'],
  communications: ['id', 'lab']
}
export const trimSearchValue = val =>
  val && typeof val === 'string' ? val?.replace(/[\u202C\u200B-\u200D\uFEFF]/g, '')?.trim() : val

export const identifierTypes = ['national_id', 'passport', 'driver_license', 'residency', 'OTHER']
